import has from 'lodash/has'

export default (obj, prop) => {
  return has(obj, prop) ? obj[prop] : null
}
